var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "House") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.96 6.44l.01.01c1.3 1.12 2.04 2.77 2.04 4.52v7c0 2.23-1.76 4.04-3.92 4.04H3.92C1.76 22.01 0 20.2 0 17.97v-7c0-1.75.74-3.4 2.04-4.52a.998.998 0 011.41.1c.36.42.32 1.05-.1 1.41C2.49 8.7 2 9.8 2 10.97v7c0 1.13.86 2.04 1.92 2.04H7v-7.64c0-1.3 1.06-2.36 2.35-2.36h3.3c1.3 0 2.35 1.06 2.35 2.36v7.64h3.08c1.06 0 1.92-.92 1.92-2.04v-7c0-1.17-.49-2.27-1.35-3.01l-6.26-5.42c-.81-.7-1.98-.7-2.79 0L6.17 5.51a.997.997 0 01-1.65-.76V1c0-.55.45-1 1-1s1 .45.99 1v1.56l1.78-1.54a4.097 4.097 0 015.41 0l6.26 5.42zM9.04 12.36V20h3.92v-7.64c0-.17-.14-.31-.31-.31h-3.3c-.17 0-.31.14-.31.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.8c967f09021bd75dd8bf95f81626b4b5.svg";
export { ForwardRef as ReactComponent };